export const DEFAULT_MIN_AGE = 0;
export const DEFAULT_MAX_AGE = 18;
